import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

// RequireAuth Higher Order Component
import RequireAuth from './components/shared/lib/RequireAuth';

import App from './components/routes/app/app';
import Home from './components/routes/Home/Home';

import Categoria from './components/routes/Categoria/Categoria';
import Tag from './components/routes/Tag/Tag';
import Ricerca from './components/routes/Ricerca/Ricerca';
import InOfferta from './components/routes/InOfferta/InOfferta';
import Prodotto from './components/routes/Prodotto/Prodotto';
import Carrello from './components/routes/Carrello/Carrello';

import Checkout from './components/routes/Checkout/Checkout';
import Accedi from './components/routes/Checkout/Accedi/Accedi';
import Ricetta from './components/routes/Checkout/Ricetta/Ricetta';
import Spedizione from './components/routes/Checkout/Spedizione/Spedizione';
import Pagamento from './components/routes/Checkout/Pagamento/Pagamento';
import Riepilogo from './components/routes/Checkout/Riepilogo/Riepilogo';
import CheckoutSuccess from './components/routes/Checkout/CheckoutResult/CheckoutSuccess';
import CheckoutFailure from './components/routes/Checkout/CheckoutResult/CheckoutFailure';
import CheckoutSatispay from './components/routes/Checkout/CheckoutSatispay/CheckoutSatispay';

import Registrazione from './components/routes/Registrazione/Registrazione';

import RecuperoPassword from './components/routes/RecuperoPassword/RecuperoPassword';
import ResetPassword from './components/routes/RecuperoPassword/ResetPassword';
import Impersona from './components/routes/RecuperoPassword/Impersona';

import Account from './components/routes/Account/Account';
import Profilo from './components/routes/Account/Profilo/Profilo';
import Ordini from './components/routes/Account/Ordini/Ordini';
import DettaglioOrdine from './components/routes/Account/Ordini/DettaglioOrdine/DettaglioOrdine';
import DatiAccount from './components/routes/Account/DatiAccount/DatiAccount';
import InvitaUnAmico from './components/routes/Account/InvitaUnAmico/InvitaUnAmico';
import CartaFedelta from './components/routes/Account/CartaFedelta/CartaFedelta';

import Pagina from './components/routes/Pagine/Pagina';

import Blog from './components/routes/Blog/List/PostList';
import Post from './components/routes/Blog/SinglePost/SinglePost';
import NotFound from './components/routes/NotFound/NotFound';

const scrollToTop = (prevState, nextState) => {
  window.scrollTo(0, 0);
};

const reloadWidgetsFeedaty = () => {
  if (typeof FeedatyWidget !== 'undefined') {
    // 1. Imposta il flag che identifica il primo caricamento dei widget su "true"
    FeedatyWidget.firstLoad = true;
    // 2. Inizializza e renderizza i widget
    FeedatyWidget.init();
    // 3. Imposta il flag che identifica il primo caricamento dei widget su "false"
    FeedatyWidget.firstLoad = false;
  }
};

const handleChangePage = () => {
  scrollToTop();
  setTimeout(() => {
    reloadWidgetsFeedaty();
  }, 500);
};

export default (
  <Route path="/" component={App} onChange={handleChangePage}>
    <IndexRoute component={Home} />

    <Route path="prodotti">
      <Route path=":category" component={Categoria} />
      <Route path=":category/:subcategory" component={Categoria} />
      <Route path=":category/:subcategory/:product" component={Prodotto} />
    </Route>

    <Route path="farmaci">
      <Route path=":category" component={Categoria} />
      <Route path=":category/:subcategory" component={Categoria} />
      <Route path=":category/:subcategory/:product" component={Prodotto} />
    </Route>

    <Route path="tag/:tag" component={Tag} />

    <Route path="ricerca/:keywords" component={Ricerca} />
    <Route path="prodotti-in-offerta" component={InOfferta} />

    <Route path="login" component={Home} />

    <Route path="carrello" component={Carrello} />

    <Route path="checkout" component={Checkout}>
      <Route path="/accedi" component={Accedi} />
      <Route path="/ricetta" component={Ricetta} />
      {/* RequireAuth() rimossa per permettere pagamento guest */}
      <Route path="/spedizione" component={Spedizione} />
      <Route path="/pagamento" component={Pagamento} />
      <Route path="/riepilogo" component={Riepilogo} />
      {/*<Route path="/:id" component={CheckoutSatispay}/>*/}
      <Route path="/checkout-success" component={CheckoutSuccess} />
      <Route path="/checkout-failure" component={CheckoutFailure} />
    </Route>

    <Route path="registrazione" component={Registrazione} />

    <Route path="recupero-password" component={RecuperoPassword} />
    <Route path="reset-password" component={ResetPassword} />
    <Route path="impersona" component={Impersona} />

    <Route path="account" component={RequireAuth()(Account)}>
      <Route path="/profilo" component={Profilo} />
      <Route path="/ordini">
        <IndexRoute component={Ordini} />
        <Route path="dettaglio-ordine/:id" component={DettaglioOrdine} />
      </Route>
      <Route path="/dati-account" component={DatiAccount} />
      <Route path="/invita-un-amico" component={InvitaUnAmico} />
      <Route path="/carta-fedelta" component={CartaFedelta} />
    </Route>

    <Route path="pagine/:slug" component={Pagina} />

    <Route path="blog">
      <IndexRoute component={Blog} />
      <Route path=":id" component={Post} />
    </Route>

    <Route path="pagina-non-trovata" component={NotFound} />
  </Route>
);
